__turbopack_context__.v({
  "root": "SharingFilter-module__KIlDoq__root",
  "shared": "SharingFilter-module__KIlDoq__shared",
});
